import { type FC, useId } from 'react'
import { FormattedMessage } from 'react-intl'

import { useGlobalConfigContext } from '../../../global-config'
import { StaticImage } from '../../../image'
import { TENANT } from '../../../tenant'
import {
  PRODUCT_ACTIVE_SUBSTANCE_TYPE,
  productAccessorGetProductActiveSubstanceType,
} from '../../model/productAccessor/productAccessorGetProductActiveSubstanceType'
import { useProductPageContext } from '../productPageContext'

import { CorticosteroidPharmacistAdvice } from './CorticosteroidPharmacistAdvice'
import { MethotrexatPharmacistAdvice } from './MethotrexatPharmacistAdvice'
import pharmacistPortrait from './pharmacist-portrait.png'

export const ProductPharmacistAdvice: FC = () => {
  const { tenant } = useGlobalConfigContext()
  const { product } = useProductPageContext()
  const headingId = useId()

  if (tenant !== TENANT.COM) {
    return null
  }

  const activeSubstanceType =
    productAccessorGetProductActiveSubstanceType(product)

  if (!activeSubstanceType) {
    return null
  }

  const isMethotrexat =
    activeSubstanceType === PRODUCT_ACTIVE_SUBSTANCE_TYPE.METHOTREXAT

  return (
    <aside
      aria-labelledby={headingId}
      className="flex w-full flex-col gap-4 overflow-hidden rounded-l bg-light-secondary-low px-4 py-6 text-dark-primary-max"
      data-qa-id="product-pharmacist-advice"
    >
      <div className="flex justify-center">
        <StaticImage
          alt=""
          className="size-24 rounded-full"
          src={pharmacistPortrait}
        />
      </div>
      <div className="flex flex-col gap-2">
        <h3 className="text-m font-medium" id={headingId}>
          <FormattedMessage id="qualityIndicator.header" />
        </h3>
        {isMethotrexat ? (
          <MethotrexatPharmacistAdvice />
        ) : (
          <CorticosteroidPharmacistAdvice />
        )}
      </div>
    </aside>
  )
}
